/**
 * Owner-spezifische API-Funktionen (Eigentümer)
 * Eigentümer-Verwaltung und ALKIS-Import
 */
import { api, getAuthHeaders, getBaseUrl } from './client';

export const ownersApi = {
  async getOwners(projectId: string, areaId: string): Promise<any[]> {
    return api.get(`/projects/${projectId}/areas/${areaId}/owners`);
  },

  async getParcelOwners(projectId: string, parcelId: string): Promise<any[]> {
    return api.get(`/projects/${projectId}/area/parcels/${parcelId}/owners`);
  },

  async getOwnerParcels(projectId: string, areaId: string, ownerId: string): Promise<any[]> {
    return api.get(`/projects/${projectId}/areas/${areaId}/owners/${ownerId}/parcels`);
  },

  async getOwnersForParcels(projectId: string, parcelIds: string[]): Promise<any[]> {
    return api.post(`/projects/${projectId}/area/parcels/owners`, { parcel_ids: parcelIds });
  },

  async getParcelsForOwners(projectId: string, areaId: string, ownerIds: string[]): Promise<any[]> {
    return api.post(`/projects/${projectId}/areas/${areaId}/owners/parcels`, { owner_ids: ownerIds });
  },

  async updateOwnerStatus(projectId: string, areaId: string, ownerId: string, status: string): Promise<any> {
    return api.patch(`/projects/${projectId}/areas/${areaId}/owners/${ownerId}`, { status });
  },

  async updateOwnerNotes(projectId: string, areaId: string, ownerId: string, notizen: string): Promise<any> {
    return api.patch(`/projects/${projectId}/areas/${areaId}/owners/${ownerId}`, { notizen });
  },

  /**
   * ALKIS-Import für Eigentümer und Flurstücke
   * Importiert Eigentümer-Daten aus einer ALKIS-XML-Datei
   */
  async importAlkisOwners(projectId: string, areaId: string, file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);

    const headers = await getAuthHeaders();
    // Entferne Content-Type Header - Browser setzt automatisch den richtigen mit boundary
    delete headers['Content-Type'];

    const response = await fetch(`${getBaseUrl()}/projects/${projectId}/areas/${areaId}/import-alkis`, {
      method: 'POST',
      headers: headers,
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.detail?.message || errorData.detail || `HTTP ${response.status}: ${response.statusText}`
      );
    }

    return response.json();
  },
};

